export default function getDataAsArrays(data) {
    const newData = {};
    const keys = Object.keys(data[0]);
    for (const key of keys) {
        newData[key] = data.map((d) => d[key]);
    }
    return newData;
}
//# sourceMappingURL=getDataAsArrays.js.map